<template>
    <modal
        :saveAction="saveAction"
        :title="$t(title)"
        :deleteAction="data._id ? data.debtReturn.date ? deleteAction : false : false"
        :id="id"
        :actionButtons="!hideForm"
        size="lg"
        :closeButton="hideForm"
        @shown="shown"
    >
        <div class="row">
            <div class="col-8">
                <div class="col mb-3 d-flex justify-content-between">
                    <b-button
                        class="btn-white"
                        v-for="(label, index) in labelsFuture"
                        :key="index"
                        @click="setDateFilter(index)"
                    >{{ $t(label) }}
                    </b-button>
                </div>
                <div class="col">
                    <date-picker v-model="data.debtReturn.date"></date-picker>
                    <b-form-textarea v-model="data.debtReturn.text" id="debt" rows="5" :placeholder="$t('Explanation of debt')"></b-form-textarea>
                </div>
            </div>
            <div class="col-4">
                <div class="col">
                    <div class="form-group">
                        <custom-switch v-model="data.debtReturn.notify" id="notify" :title="$t('Notify client')"></custom-switch>
                    </div>
                </div>
                <appointment-notification v-if="data.debtReturn.notify" :start-at="data.debtReturn.date" v-model="data.debtReturn.timeTemplate" :render-switch="true"></appointment-notification>
            </div>
        </div>

    </modal>
</template>

<script>
    import Modal from "@/components/Modal.vue";
    import DatePicker from "@/components/DatePicker.vue";
    import {mapActions} from 'vuex';
    import CustomSwitch from "@/components/CustomSwitch.vue";
    import AppointmentNotification from "@/components/TimeTemplates/AppointmentNotification";

    export default {
        name: 'DebtReturnModal',
        props: ['id'],
        components: {
            Modal,
            DatePicker,
            CustomSwitch,
            AppointmentNotification
        },
        data() {
            return {
                labelsFuture: {
                    'tomorrow': 'Tomorrow',
                    'after_three_day': '3 Days',
                    'next_week': 'Week',
                    'next_month': 'Month',
                },
                hideForm: false,
                title: 'Debt details',
                errors: {},
                data: {
                    debtReturn: {
                        date: null,
                        text: null,
                    }
                },
                date: null,
            }
        },
        computed: {},
        methods: {
            ...mapActions('customers', {updateCustomer: 'patch'}),

            deleteAction() {
                this.updateCustomer([this.data._id, {debtReturn: {}}]).then((res) => {
                    this.$toasted.global.success({
                        message: 'Comment has been removed'
                    });
                    this.close();
                });
            },
            shown() {
                this.errors = {};
                this.data = {};
                const {Customer} = this.$FeathersVuex;
                let data = Customer.getFromStore('temp');
                if (data) {
                    delete data._id;
                    this.data = JSON.parse(JSON.stringify(data['customer']));
                    new Customer({
                        customer: {},
                        model: {},
                        _id: 'temp'
                    });
                }
                // this.data.label.focus();
            },
            saveAction() {
                this.updateCustomer([this.data._id, {debtReturn: this.data.debtReturn}]).then((res) => {
                    this.$toasted.global.success({
                        message: 'Debt explanation updated'
                    });
                    this.close();
                });
            },
            close() {
                this.$root.$emit('bv::hide::modal', this.id);
            },

            setDateFilter(item) {
                this.date = this.$moment();
                switch (item) {
                    case 'tomorrow':
                        this.date.add(1, 'days');
                        break;
                    case 'after_three_day':
                        this.date.add(3, 'days');
                        break;
                    case 'next_week':
                        this.date.add(1, 'weeks');
                        break;
                    case 'next_month':
                        this.date.add(1, 'months');
                        break;
                    default:
                    // code block
                }
                this.data.debtReturn.date = this.date._d;
            },
        }
    }
</script>

<style lang="scss">
</style>
